import { CrossSellerProduct } from '../components/CrossSellerProduct';
import { useCrossSellerProductService } from '../services/useCrossSellerProductService';

export const CrossSellerProductContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { targetRef, cross_seller_product_count, handleClick } = useCrossSellerProductService();
  if (!cross_seller_product_count) {
    return null;
  }
  return (
    <div ref={targetRef}>
      <CrossSellerProduct count={cross_seller_product_count} onClick={handleClick} />
    </div>
  );
};
